import { Message } from "pixel";

export const getMessageFromErrorsArray = (errors: any) => {
  const errorsArray: string[] = [];

  errors?.forEach((error: any) => {
    const errorField = error?.field;
    const errorMessage = error?.message;
    const currentError = errorField + " " + errorMessage;

    errorsArray?.push(currentError);
  });

  return errorsArray;
};

export const getHelperOrErrorText = ({
  error,
  successMessage,
  helperMessage,
}: {
  error: string | string[] | null | undefined;
  successMessage: string | null | undefined;
  helperMessage?: string;
}) => {
  if (error) {
    if (Array.isArray(error)) {
      return error?.map((e) => <Message type="error" variant="field" title={e} />);
    }
    return <Message type="error" variant="field" title={error} />;
  }
  if (successMessage) {
    return <Message type="success" variant="field" title={successMessage} />;
  }

  if (helperMessage) {
    return <Message type="helper" variant="field" title={helperMessage} customClass="mb-5" />;
  }
};

export const isLicenceCodePOA = (license_code?: string | null) => license_code === "000000-0";

interface ErrorResponse {
  data: {
    error: {
      status: number | null;
      code: string | null;
      message: string | null;
      errors: Array<{
        field: string | null;
        message: string | null;
      }> | null;
    };
  };
}

export function isErrorResponse(error: unknown): error is ErrorResponse {
  return (
    (typeof error === "object" &&
      error !== null &&
      "data" in error &&
      typeof (error as ErrorResponse).data === "object" &&
      "error" in (error as ErrorResponse).data &&
      typeof (error as ErrorResponse).data.error === "object" &&
      "status" in (error as ErrorResponse).data.error &&
      typeof (error as ErrorResponse).data.error.status === "number") ||
    ("null" &&
      "code" in (error as ErrorResponse).data.error &&
      typeof (error as ErrorResponse).data.error.code === "string") ||
    ("null" &&
      "message" in (error as ErrorResponse).data.error &&
      typeof (error as ErrorResponse).data.error.message === "string") ||
    ("null" &&
      "errors" in (error as ErrorResponse).data.error &&
      ((Array.isArray((error as ErrorResponse).data.error.errors) &&
        (error as ErrorResponse).data.error.errors?.every(
          (e) =>
            (typeof e === "object" && "field" in e && typeof e.field === "string") ||
            (null && "message" in e && typeof e.message === "string") ||
            null
        )) ||
        (error as ErrorResponse).data.error.errors === null))
  );
}
